export default class StickyAddToCart {
    constructor() {
        this.btn = document.getElementById('sticky-add-to-cart');
        this.target = document.querySelector('.product-hero-add-to-cart');
        if (!this.btn || !this.target) return;

        this.observer = null;
        this.init();
    }

    init() {
        this.setPosition();
        this.btn.addEventListener('click', () => this.scrollToTarget());

        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    this.btn.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 0);
                });
            },
            { rootMargin: '-10px 0px 0px 0px', threshold: 0 }
        );

        this.observer.observe(this.target);

        window.addEventListener('resize', () => this.setPosition());
    }

    setPosition() {
        const rect = this.target.getBoundingClientRect();
        if (rect.right > 0) {
            this.btn.style.right = (document.documentElement.clientWidth - rect.right - 20) + 'px';
        }
    }

    scrollToTarget() {
        const target = document.querySelector(this.btn.dataset.target) || document.querySelector('.product-hero');
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
}
